import { flow } from 'lodash';
import { connect } from 'react-redux';
import Scoreboard from './Scoreboard';

const mapStateToProps = state => ({
  scores: state.task.scores,
  possibleScores: state.task.possibleScores
});

export default flow(connect(mapStateToProps))(Scoreboard);



// WEBPACK FOOTER //
// ../core/src/components/Scoreboard/index.js